<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Entity Details -->
<div class="entityDetails" [hidden]="minimise">
  <table style="width: 100%;">
    <tbody>
      <tr>
        <td class="LayerLine1" nowrap>Entity:</td>
        <td class="LayerData1" nowrap>{{ rowData.LEID }} : {{ rowData.LE_NAME }}</td>
        <td class="LayerLine1" nowrap>Business:</td>
        <td class="LayerData1" nowrap>{{ rowData.ME_CODE }} : {{ rowData.ME_NAME }}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Tabs -->
<div [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    <li [class.active]="activeTab === 0">
      <a (click)="activeTab = 0" style="cursor: pointer;" class="btn-sm">Section 174 Allocations</a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
    <!-- Section 174 Allocations Tab -->
    @if (activeTab === 0) {
<div class="tab-pane active">
      <div class="modal-body">
        <!-- Loading Spinner -->
        @if (sectionLoading) {
<div class="loading-container">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
}

        <!-- Form Content -->
        @if (!sectionLoading) {
<div>
          <form class="form-horizontal" novalidate>
            <div class="table-container">
              <table class="section174-table table table-hover table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th style="width: 10%">Account</th>
                    <th style="width: 14%">SIC Code</th>
                    <th style="width: 10%">IN - Out 174</th>
                    <th style="width: 10%">Book Amt</th>
                    <th style="width: 10%">Book Amt Sec 174</th>
                    <th style="width: 10%">Temp Tax Adj</th>
                    <th style="width: 10%">Temp Tax Adj Sec 174</th>
                    <th style="width: 10%">Perm Tax Adj</th>
                    <th style="width: 10%">Perm Tax Adj Sec 174</th>
                  </tr>
                </thead>

                <!-- No Records -->
                @if (noRecords) {
<tbody>
                  <tr>
                    <td class="loading-table" colspan="9">
                      <div style="margin-top: 20px; text-align: center;">
                        <b>No Data Available</b>
                      </div>
                    </td>
                  </tr>
                </tbody>
}

                <!-- Data Rows -->
                @if (!noRecords) {
<tbody>
                  @for (o of section174adjList; track trackByIndex(i, o); let i = $index) {
<tr>
                    <!-- Account Column with +/- buttons -->
                    <td>
                      <div class="input-group">
                        <input class="form-control" [ngModel]="o.ACCT" readonly [ngModelOptions]="{standalone: true}">
                        @if (o.PLUS_MINUS_FLAG === 'PLUS') {
<span class="input-group-addon add-btn" 
                              
                              (click)="addRow(o, i)">
                          <i class="fa fa-plus-circle" style="color: green; font-size: 22px;"></i>
                        </span>
}
                        @if (o.PLUS_MINUS_FLAG === 'MINUS') {
<span class="input-group-addon delete-btn" 
                              
                              (click)="deleteRow(o)">
                          <i class="fa fa-minus-circle" style="color: red; font-size: 22px;"></i>
                        </span>
}
                      </div>
                    </td>

                    <!-- SIC Code Dropdown with filter -->
                    <td>
                      <ap-dropdown class="field-full-width" [list]="sic_code_display" [selectType]="'single'"
                        [title]="'SIC Code'" [hideTitleOnInput]="true" [inputAriaLabel]="'SIC Code'"
                        [(ngModel)]="o.selectedSicItem" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onRowDropdownSelect($event, o, 'SIC_CODE', 'selectedSicItem')">
                        @for (item of sic_code_display; track $index) {
                          <ap-dropdown-list-item #dropdownListItem [item]="item"
                            [ariaLabel]="setDropdownAriaLabel(item, 'SIC Code')"
                            (onSelectItem)="onRowDropdownSelectItem($event, o, 'selectedSicItem')"></ap-dropdown-list-item>
                        }
                      </ap-dropdown>
                    </td>

                    <!-- IN - Out 174 Dropdown (no filter, only 2 options) -->
                    <td>
                      <ap-dropdown class="field-full-width" [list]="in_out_display" [selectType]="'single'"
                        [title]="'IN - Out 174'" [hideTitleOnInput]="true" [inputAriaLabel]="'IN - Out 174'"
                        [(ngModel)]="o.selectedInOutItem" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onRowDropdownSelect($event, o, 'IN_OUT_174', 'selectedInOutItem')">
                        @for (item of in_out_display; track $index) {
                          <ap-dropdown-list-item #dropdownListItem [item]="item"
                            [ariaLabel]="setDropdownAriaLabel(item, 'IN - Out 174')"
                            (onSelectItem)="onRowDropdownSelectItem($event, o, 'selectedInOutItem')"></ap-dropdown-list-item>
                        }
                      </ap-dropdown>
                    </td>

                    <!-- Book Amt (readonly) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right" 
                             [(ngModel)]="o.BOOK_AMT"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             readonly>
                    </td>

                    <!-- Book Amt Sec 174 (conditionally editable) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right"
                             [(ngModel)]="o.BOOK_AMT_174"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             [readonly]="o.BOOK_AMT_FLAG === 'Y'">
                    </td>

                    <!-- Temp Tax Adj (readonly) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right" 
                             [(ngModel)]="o.TEMP_TAX_ADJ"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             readonly>
                    </td>

                    <!-- Temp Tax Adj Sec 174 (conditionally editable) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right"
                             [(ngModel)]="o.TEMP_TAX_ADJ_174"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             [readonly]="o.TEMP_TAX_AMT_FLAG === 'Y'">
                    </td>

                    <!-- Perm Tax Adj (readonly) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right" 
                             [(ngModel)]="o.PERM_TAX_ADJ"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             readonly>
                    </td>

                    <!-- Perm Tax Adj Sec 174 (conditionally editable) -->
                    <td class="text-right">
                      <input type="text" 
                             class="form-control text-right"
                             [(ngModel)]="o.PERM_TAX_ADJ_174"
                             [ngModelOptions]="{standalone: true}"
                             onlyIntegersWithLength
                             [readonly]="o.PERM_TAX_AMT_FLAG === 'Y'">
                    </td>
                  </tr>
}
                </tbody>
}
              </table>
            </div>
          </form>
        </div>
}
      </div>
    </div>
}

  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
